import { FC, useMemo } from 'react'
import { SnowflakeResultSet } from '../../../utils/types'
import { formatHeaderLabel } from '../../../utils/formatHeader'
import NexaTable, { NexaTableCell, NexaTableRow } from './NexaTable'

interface ResultSetTableProps {
  resultSet: SnowflakeResultSet
  title?: string
}

// Normalize Snowflake cell values for display:
//   - JSON-encoded arrays (e.g. email lists) → comma-joined text
//   - everything else passes through to NexaTable's default renderer
const normalizeCellValue = (value: NexaTableCell): NexaTableCell => {
  if (typeof value === 'string' && value.startsWith('[')) {
    try {
      const parsed = JSON.parse(value)
      if (Array.isArray(parsed)) {
        return parsed.join(', ')
      }
    } catch {
      // Not JSON — fall through and render as-is.
    }
  }
  return value
}

const ResultSetTable: FC<ResultSetTableProps> = ({ resultSet, title }) => {
  const headers = useMemo(
    () => resultSet.resultSetMetaData.rowType.map((col) => formatHeaderLabel(col.name)),
    [resultSet.resultSetMetaData.rowType]
  )

  const rows = useMemo<NexaTableRow[]>(
    () => resultSet.data.map((row) => row.map(normalizeCellValue)),
    [resultSet.data]
  )

  return <NexaTable headers={headers} rows={rows} title={title} />
}

export default ResultSetTable
